import { createContext } from "react";
import { type User } from "firebase/auth";

export interface AuthContextType {
  user: User | null;
  loading: boolean;
}

const AuthContext = createContext<AuthContextType>({
  user: null,
  loading: true,
});

export default AuthContext;
